export const writingTabs = [
  { text: '글쓰기', key: 'writePost' },
  { text: '내가 쓴 글', key: 'myPosts' },
];

export const basicInfoTabs = [
  { text: '기본 정보', key: 'basicInfo' },
  { text: '매장 설명', key: 'storeInfo' },
];

export const couponTabs = [
  { text: '쿠폰 등록하기', key: 'addCoupon' },
  { text: '쿠폰 UI 서비스 신청하기', key: 'uiService' },
];

export const customerTabs = [
  { text: '전체', key: 'all' },
  { text: '신규', key: 'new' },
  { text: '단골', key: 'regular' },
];

export const customerTabMenu = [
  { text: '고객관리', key: 'manage' },
  { text: '방문분석', key: 'visit' },
  { text: '월간 분석 레포트', key: 'report' },
];

export const indexMenu = [
  { text: '요일별', key: 'dailyVisit' },
  { text: '시간대별', key: 'timeVisit' },
  { text: '인구통계별', key: 'demographicVisit' },
];

export const visitTabs = [
  { text: '오늘', key: 'today' },
  { text: '이번주', key: 'week' },
  { text: '이번달', key: 'month' },
  { text: '3개월', key: 'quarter' },
];
